import { AfterViewInit, Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { SharedModule } from '../SharedModule';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SowService } from '../../services/sow.service';
import { ReportsService } from '../../services/reports.service';
import { ReceiptsService } from '../../services/receipts.service';
import { SpinnerService } from '../generic/spinner/spinner.service';
import { environment } from '../../../environments/environment';
import * as crypto from "crypto-js";
import { SecurityService } from '../../services/security';

@Component({
  selector: 'app-report-management',
  standalone: true,
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './report-management.component.html',
  styleUrls: ['./report-management.component.css']
})
export class ReportManagementComponent implements OnInit, AfterViewInit {
  user !: string;
  name !: string;
  profile !: string;

  listTimesheetPerYear: any = [] ;
  listTimesheetDetPerYear: any = [] ;
  loading: boolean = true;
  search: any = {};
  searchDet: any = {};
  selectedItem: any = {};
  selectedItemSow: any = {};
  listYear: any = [];
  listMonth: any = [];
  groupedData: any = [];
  isInternal: boolean = false;
  permissions: any = {};
  roles: any = [];
  userCode: string = '';
  employeer: string = '';

  constructor(
    private __dialogService : DialogService,
    private __receiptsService : ReceiptsService,
    private __sowService: SowService,
    private __reportsService: ReportsService,
    private __spinnerService: SpinnerService,
    private __securityService: SecurityService
  ) { }

  ngOnInit(): void {
    this.user = localStorage.getItem('user')!;
    this.name = localStorage.getItem('name')!;
    this.profile = localStorage.getItem('profile')!;
    this.search.YEAR = new Date().getFullYear();
    this.searchDet.YEAR = new Date().getFullYear();
    this.searchDet.MONTH = new Date().getMonth();
    if (this.profile !== 'undefined') {
      if (this.profile == 'Contractors') {
        this.employeer = localStorage.getItem('employeer')!;
        this.userCode = localStorage.getItem('userCod')!;
      }
      this.permissions = JSON.parse(''+sessionStorage.getItem('permissions'));
      this.roles = this.permissions.roles || [];
      this.getListTimesheetPerYear();
      this.getListTimesheetDetPerYear();
    } else {
      this.getInfoUser();
    }
    this.getListYears();
    this.getListMonth();
  }

  getInfoUser(){
      let usEnc = ''+localStorage.getItem('user');
      let param = {
        "password": '',
        "mail": usEnc,
        "loginType": 1
      }

      this.__securityService.authentication(param).subscribe( (data: any) => {
        if(data.an_resultado == 1){
          this.userCode = data.res_obj_login.username;
          this.employeer = data.res_obj_login.employeer;
          this.roles = data.res_obj_login.permissions.roles || [];
          this.getListTimesheetPerYear();
          this.getListTimesheetDetPerYear();
        }
      });
    }

  getListYears() {
    //this.__spinner.show({ type: 'loader' });
    this.listYear = [];
    this.__receiptsService.getListYears().subscribe((resp: any) => {
      this.listYear = resp.listYear;
      //.__spinner.close();
    });
  }

  getListMonth() {
    //this.__spinner.show({ type: 'loader' });
    this.listMonth = [];
    this.__receiptsService.getListMonth().subscribe((resp: any) => {
      this.listMonth = resp.listMonth;
      //.__spinner.close();
    });
  }

  getListTimesheetPerYear() {
    this.__spinnerService.show({ type: 'dark' });
    this.loading = true;
    //this.__spinner.show({ type: 'loader' });
    this.roles.forEach((role: any) => {
      if (role.roleDesc == 'VendorManagers') {
        this.search.isvendor = 1;
        this.search.vendor = role.vendor;
      } else if (role.roleDesc == 'Contractors') {
        this.search.isvendor = 0;
        this.search.vendor = this.employeer;
        this.search.resourceId = this.userCode;
      } else {
        this.search.isvendor = 0;
      }
    });
    this.listTimesheetPerYear = [];

    this.__reportsService.getListTimesheetPerYear(this.search).subscribe((resp: any) => {
      this.listTimesheetPerYear = resp.listTimesheetPerYear;
      this.loading = false;
      this.__spinnerService.close();
      //.__spinner.close();
    });
  }

  onInputChange(event: any) {
    this.getListTimesheetPerYear();
  }

  onInputChangeDet(event: any) {
    this.getListTimesheetDetPerYear();
  }

  selected(item: any) {
    this.selectedItem = item;
  }

  getListTimesheetDetPerYear() {
    this.__spinnerService.show({ type: 'dark' });
    this.loading = true;
    //this.__spinner.show({ type: 'loader' });
    this.roles.forEach((role: any) => {
      if (role.roleDesc == 'VendorManagers') {
        this.searchDet.isvendor = 1;
        this.searchDet.vendor = role.vendor;
      } else if (role.roleDesc == 'Contractors') {
        this.searchDet.isvendor = 0;
        this.searchDet.vendor = this.employeer;
        this.searchDet.resourceId = this.userCode;
      } else {
        this.searchDet.isvendor = 0;
      }
    });
    this.listTimesheetDetPerYear = [];
    const groupedMap = new Map<string, any[]>();

    this.__reportsService.listTimesheetDetPerYear(this.searchDet).subscribe((resp: any) => {
      this.listTimesheetDetPerYear = resp.listTimesheetDetPerYear;
      this.listTimesheetDetPerYear.forEach((item: any) => {
        if (!groupedMap.has(item.USER)) {
          groupedMap.set(item.USER, []);
        }
        groupedMap.get(item.USER)?.push(item);
      });

      this.groupedData = Array.from(groupedMap.entries()).map(([user, rows]) => ({
        USER: user,
        rows: rows
      }));
      this.loading = false;
      this.__spinnerService.close();
      //.__spinner.close();
    });
  }

  selectedSow(item: any) {
    this.selectedItemSow = item;
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  ngAfterViewInit(): void {
    $(".right-side-toggle").click(function () {
      $(".right-sidebar").slideDown(50), $(".right-sidebar").toggleClass("shw-rside")
    });
    $(".nav-lock").unbind();
    $(".nav-lock").on("click", function () {
      $("body").toggleClass("lock-nav"), $(".nav-lock i").toggleClass("mdi-toggle-switch-off"), $("body, .page-wrapper").trigger("resize")
    });
  }
}
